/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {UiTableCell, UiTableRow} from "components/Ui/UiTable";
import {currencyNumberFormat} from "utils/utility";
import {PencilIcon, TrashIcon} from '@heroicons/react/24/outline'

import React from 'react';
import {useTranslation} from "react-i18next";
import {type SummedVoucher, useVouchers} from "utils/voucherUtils";
import {PackagesCart} from "types/entities/PackagesCart";
import type {OfferCalculation} from "types/entities/OfferCalculation";
import type {Offer} from "types/entities/Offer";
import {useVoucherUtilModals} from "utils/voucherUtilModals";

const PackagesCartItemVoucher = (props: {
    packagesCart: PackagesCart
    calculation: OfferCalculation
    offer: Offer
    disabled: boolean
}) => {
    const { t } = useTranslation()
    const { summedVouchers } = useVouchers(props.packagesCart)
	const {onEditCalculationDiscountHandler, onDeleteCalculationDiscountHandler} = useVoucherUtilModals()



    return (
        <>
            {summedVouchers.map((summedVoucher: SummedVoucher) => {
                const voucherDisplayPrice = props.calculation.is_netto
                    ? (summedVoucher.price ?? 0) / 1.081
                    : (summedVoucher.price ?? 0)

                return (
                    <UiTableRow key={`discount-row-${summedVoucher.voucher_id}`}>
                        <UiTableCell fontWeight="medium">
                            <span className="text-red-600 dark:text-red-400">{t('Discount')}</span>
                        </UiTableCell>
                        <UiTableCell align="right">
                            <span className="text-red-600 dark:text-red-400 font-semibold">
                                - {currencyNumberFormat(voucherDisplayPrice)}
                            </span>
                        </UiTableCell>
                        <UiTableCell align="right">
                            <div className="flex gap-1.5 justify-end">
                                <button
                                    onClick={() => onEditCalculationDiscountHandler(props.calculation, props.packagesCart, props.offer, summedVoucher.voucher_id)}
                                    disabled={props.disabled}
                                    className="p-1 bg-blue-500 hover:bg-blue-600 dark:bg-blue-600 dark:hover:bg-blue-700 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                    title={t('Edit Discount') as string}
                                >
                                    <PencilIcon className="w-4 h-4 text-white" />
                                </button>
                                <button
                                    onClick={() => onDeleteCalculationDiscountHandler(props.packagesCart, props.offer, summedVoucher.voucher_id)}
                                    disabled={props.disabled}
                                    className="p-1 bg-red-500 hover:bg-red-600 dark:bg-red-600 dark:hover:bg-red-700 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                    title={t('Remove Discount') as string}
                                >
                                    <TrashIcon className="w-4 h-4 text-white" />
                                </button>
                            </div>
                        </UiTableCell>
                    </UiTableRow>
                )
            })}
        </>
    )
}

export default PackagesCartItemVoucher
